var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.083,
    height: 18.055,
    viewBox: "0 0 14.083 18.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rating-Star-Ribbon--Streamline-Ultimate",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8298",
    "data-name": "Path 8298",
    d: "M16.645,17.285a.77.77,0,0,1-1.187.646L10.1,14.467,4.749,17.93a.769.769,0,0,1-1.187-.645V1.77A.77.77,0,0,1,4.332,1H15.875a.77.77,0,0,1,.77.77V17.285Z",
    transform: "translate(-3.562 -1)",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8301",
    "data-name": "Path 8301",
    d: "M11.335,5.37l.987,1.939h1.924a.472.472,0,0,1,.331.823L12.91,9.874,13.833,12a.5.5,0,0,1-.716.63l-2.234-1.255L8.651,12.628A.5.5,0,0,1,7.935,12l.923-2.125L7.189,8.132a.471.471,0,0,1,.332-.823H9.445l.986-1.939a.509.509,0,0,1,.9,0Z",
    transform: "translate(-4.342 -1.921)",
    fill: "none",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.153c98ffef72a3c29ca661eb46ca35cf.svg";
export { ForwardRef as ReactComponent };